import script from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"

import "./OAuthLogin.vue?vue&type=style&index=0&id=27605a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27605a14"]])

export default __exports__